/**
 * Sayfalama metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @returns {Object} Sayfalama metodları
 */
export const createDocumentPaginationMethods = (state) => {
  const { pagination, documents } = state

  /**
   * Sayfalamayı güncelle
   * @param {Object} newPagination - Yeni sayfalama ayarları
   */
  const updatePagination = (newPagination) => {
    pagination.currentPage = newPagination.currentPage
    pagination.pageSize = newPagination.pageSize

    // Sayfalamayı yeniden hesapla
    const total = documents.value.length
    pagination.total = total
    const start = (pagination.currentPage - 1) * pagination.pageSize
    const end = Math.min(start + pagination.pageSize, total)
    pagination.startItem = total ? start + 1 : 0
    pagination.endItem = end
  }

  // Public API
  return {
    updatePagination,
  }
}